<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">
                                {{ flashMessage }}
                            </div>
                        </div>
                    </div>
                    <div id="details" class="row">
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                        <label>City</label>
                                        <select required name="cityId" class="form-control" :disabled="($route.params && $route.params._id && $route.params._id != '0') || isCityDisable" v-model="vehicle.cityId">
                                            <option value="" disabled>Select City Name</option>
                                            <option v-for="cityId in citys" :value="cityId.id">{{ cityId.name }}
                                            </option>
                                        </select>
                                        <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">This is required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vNumber)">
                                        <label>Vehicle Number</label>
                                        <input @input="vehicle.vNumber = vehicle.vNumber.toUpperCase()" maxlength="13" type="text" name="vNumber" class="form-control" required v-model="vehicle.vNumber" placeholder="Vehicle Number" pattern="^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$" />
                                        <field-messages name="vNumber" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">
                                                Vehicle Number is a required field
                                            </div>
                                            <div slot="pattern">
                                                Enter the valid vehicle number [Eg:- DL 00 XX 0000].
                                            </div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.vMakeYear)">
                                        <label for="dateAdded">Make Year</label>
                                        <date-picker :not-after="disabledAfter"  id="vMakeYear" v-model="vehicle.vMakeYear" lang="en" name="vehicleMakeYear" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="vMakeYear" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Make Year is a required field</div>
                                            <div slot="pattern">Make Year is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
    
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.vModelName)">
                                        <label>Model Name</label>
                                        <input maxlength="25" type="text" name="vModelName" class="form-control"  v-model="vehicle.vModelName" placeholder="Model Name" pattern="^[^0-9][a-zA-Z0-9 ]{0,25}[^\s]$" />
                                        <field-messages name="vModelName" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Model Name is a required field</div>
                                            <div slot="pattern">
                                                Alphabets/Numbers are allowed.
                                            </div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.assignGpsId)">
                                        <label>Assign GPS ID</label>
                                        <input maxlength="25" type="text" name="assignGpsId" class="form-control"  v-model="vehicle.assignGpsId" placeholder="Assign GPS ID" pattern="^(?!\s)(?![\s\S]*\s$)[a-zA-Z0-9\s]{0,25}$" />
                                        <field-messages name="assignGpsId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">
                                                Assign GPS ID is a required field
                                            </div>
                                            <div slot="pattern">
                                                Alphabets/Numbers are allowed.
                                            </div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                        </vue-form>
    
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'vehicles' }">
                                <button class="mr-5 btn btn-default" type="button">
                                    Cancel
                                </button>
                            </router-link>
                            <button class="mr-2 btn gradientbt" type="submit" @click="createVehicles" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id == '0'">
                                Save
                            </button>
                            <button class="btn gradientbt mr-5" type="submit" @click="updateVehicles" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id != '0'">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </template>
    
    <script>
    import store from "../../../store";
    import {
        formService,
        eventBus,
        vehiclesService
    } from "../../../services";
    import {
        EVENTS
    } from "../../../config";
    import {
        USER_ROLES
    } from "../../../config";
    import {
        mapState
    } from "vuex";
    
    export default {
        name: "vehicleCreates",
        data() {
            return {
                isCityDisable: false,
                ready: false,
                USER_ROLES: USER_ROLES,
                loading: false,
                flash: false,
                flashType: null,
                flashMessage: "",
                EVENTS: EVENTS,
                formstate: {},
                vehicle: {
                    vType: "",
                    cityId: "",
                },
                oldVehicle: {},
                vehicleId: [],
                data: {},
                disabledAfter: new Date(),
                citys: {},
            };
        },
        mounted() {
            this.getCityList();
            eventBus.$on('cityIdChanged', this.onChecked);
            if(this.$store.state.auth.user.role.key !== "cityAdmin" || this.$store.state.auth.user.role.key !== "subCityAdmin"){
                this.isCityDisable = true
                this.vehicle.cityId = this.$store.state.auth.cityId.value
            }
        },
        beforeDestroy() {
            eventBus.$off('cityIdChanged', this.onChecked);
        },
        methods: {
            fieldClassName: formService.fieldClassName,
            disableDate(Date, currentValue) {
                return true;
            },

            onChecked(option){
                this.vehicle.cityId = option.value
            },
            getCityList() {
                if (this.$store.state.auth.user.role.key === "cityAdmin" || this.$store.state.auth.user.role.key === "subCityAdmin") {
                    const {
                        _id,
                        cityName
                    } = this.$store.state.auth.user.cityId;
                    this.citys = [{
                        id: _id,
                        name: cityName
                    }];
                    this.vehicle["cityId"] = _id;
                    this.isCityDisable = true;
                    return;
                }
                this.loading = true;
                const params = {};
                let cityList = [];
                this.$cityRepository
                    .collectionCitysList(params)
                    .then((res) => {
                        this.loading = false;
                        res.data.response.forEach((element) => {
                            if (element.status === true) {
                                cityList.push({
                                    name: element.cityName,
                                    id: element._id,
                                });
                            }
                        });
                        cityList.sort((item1, item2) => {
                            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                        });
                        this.citys = cityList;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error("citys.requestFunction-error:", error);
                        this.$snotify.error("Get citys list failed", "Error!");
                    });
            },
            getVehicles() {
                const params = {};
                return this.$vehicleDataRepository
                    .find(this.$route.params._id, params)
                    .then((response) => {
                        this.vehicle = response.data;
                        this.oldVehicle = _.cloneDeep(this.vehicle);
                        this.$store.dispatch("setBreadcrumbTitle", this.vehicle.vNumber);
                    })
                    .catch((error) => {
                        console.error("Vehicles-error:", error);
                        this.$snotify.error("Get Vehicles failed", "Error!");
                    });
            },
    
            createVehicles() {
                this.loading = true;
                this.vehicle["vNumber"] = this.vehicle.vNumber.toUpperCase();            
                if(this.vehicle.vType == ""){
                  delete this.vehicle.vType;
                }
                return vehiclesService
                    .addVehicles(this.vehicle)
                    .then((response) => {
                        this.loading = false;
                        this.flash = false;
                        this.$snotify.success(
                            `The ${this.vehicle.vNumber} has been added successfully.!`
                        );
                        this.$router.push("/vehicles");
                    })
                    .catch((error) => {
                        this.loading = false;
                        if (error.data.message === "Vehicle Number Already Exist!!") {
                            this.$snotify.error("Vehicle Number Already Exist!", "Error!");
                        } else if (error.data.message === "GPS Number Already Exist!!") {
                            this.$snotify.error("GPS Number Already Exist!", "Error!");
                        }
                    });
            },
    
            clearChanges() {
                this.vehicle = _.cloneDeep(this.oldVehicle);
                this.formstate._reset();
            },
            updateVehicles() {
                const id = this.$route.params._id;
                this.loading = true;
                this.data = {};
                this.data["vNumber"] = this.vehicle["vNumber"].toUpperCase();
                this.data["vMakeYear"] = this.vehicle["vMakeYear"];
                this.data["vModelName"] = this.vehicle["vModelName"];
                this.data["assignGpsId"] = this.vehicle["assignGpsId"];
                this.data["cityId"] = this.vehicle["cityId"];
                this.data["_id"] = this.$route.params._id;        
                return vehiclesService
                    .updateVehicle(id, this.data)
                    .then((response) => {
                        this.loading = false;
                        this.flash = false;
                        this.formstate._reset();
                        this.oldVehicle = _.cloneDeep(this.vehicle);
                        this.$snotify.success(
                            `The ${this.vehicle.vNumber}  has been updated successfully.`
                        );
                        this.$router.push("/vehicles");
                    })    
                    .catch((error) => {
                        this.loading = false;
                        if (error.data.message === "vehicle is currently assignment to an ongoing trip") {
                            this.$snotify.error('Vehicle details cannot be updated while there is an ongoing trip for this vehicle', "Error!");
                        } else {
                            this.$snotify.error(error.data.message, "Error!");
                        }
                    });
            },
        },
        created() {
            

            this.vehicle.cityId = this.$store.state.auth.cityId.value
          
            const promises = [];
            this.loading = true;
            if (
                this.$route.params &&
                this.$route.params._id &&
                this.$route.params._id != "0"
            ) {
                promises.push(this.getVehicles());
            }
            Promise.all(promises)
                .then(() => {
                    this.loading = false;
                    this.ready = true;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        beforeDestroy() {},
    
        fieldClassName: function (field) {
            if (!field) {
                return "";
            }
            if ((field.$touched || field.$submitted) && field.$valid) {
                return "has-success";
            }
            if ((field.$touched || field.$submitted) && field.$invalid) {
                return "has-danger";
            }
        },
    };
    </script>
    
    <style scoped>
    .required-field>label::after {
        content: "*";
        color: red;
        margin-left: 0.25rem;
    }
    
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    
    .has-danger {
        color: red;
    }
    
    .mt {
        margin-top: 7px;
    }
    
    .gradientbt {
        background: #0f6940;
        color: white;
    }
    
    .inputwrapper {
        position: relative;
    }
    
    .maps {
        position: absolute;
        top: 7px;
        right: 10px;
    }
    </style>
    


// WEBPACK FOOTER //
// vehicleCreates.vue?da7835f0